export const signIn = (user) => ({ type: 'SIGN_IN', data: { user } });

export const signOut = () => ({ type: 'SIGN_OUT' });

export const tokenToUser = (token) => ({
   id: token.data.user.id,
   email: token.data.user.email,
   name: token.data.user.name,
   consentApprovedAt: token.data.user.catalog_consent_approved_at
});

const authInitialState = { user: null };

const auth = (state = authInitialState, action) => {
   switch (action.type) {
      case 'SIGN_IN':
         return {
            ...state,
            user: action.data.user
         };
      case 'SIGN_OUT':
         localStorage.removeItem('token');
         return {
            ...state,
            user: null
         };
      default:
         return state;
   }
};

export default auth;
